import { render } from "./VatSettingsLoader.vue?vue&type=template&id=1d89f258&scoped=true"
import script from "./VatSettingsLoader.vue?vue&type=script&lang=js"
export * from "./VatSettingsLoader.vue?vue&type=script&lang=js"

import "./VatSettingsLoader.vue?vue&type=style&index=0&id=1d89f258&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d89f258"]])

export default __exports__